angular.module 'zc.projects.reports'

.config ($stateProvider) ->

  $stateProvider
  .state 'admin.projects.reports',
    url: '/reports'
    views:
      'content@':
        templateUrl: '/templates/projects.reports/list.html'
        controller: 'ReportsCtrl'

  .state 'admin.projects.reports.show',
    url: '/{reportId:int}/:status'
    views:
      'content@':
        templateUrl: '/templates/projects.reports/show.html'
        controller: 'ReportCtrl'



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.reports/routes.js.coffee